import { Form } from "@unform/web";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  button {
    width: 30%;
  }

  ${media.lessThan("medium")`
    button {
      width: 100%;
    }
  `}
`;

export const BackButton = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const HideDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 10px;

  h2 {
    font-size: 32px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  span {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.neutral.cinza950};

  position: fixed;
  top: 0;
  left: 0;

  z-index: 9999;
`;

export const ProjectHeader = styled.div`
  display: flex;

  width: 100%;
  gap: 10px;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 230px;
    max-width: 260px;
  }

  ${media.lessThan("medium")`
    flex-direction: column;
    align-items: center;
    gap: 10px;

    img {
      max-width: 100%;
      max-height: 100px;
    }
  `}
`;

export const DownloadButton = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  ${media.lessThan("medium")`
    display: none;
  `}
`;

export const HasInterest = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const PendingValidations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  h3 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const PendingValidation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  span {
    font-size: 14px;
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }

  strong {
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  button {
    width: 200px;
  }

  ${media.lessThan("medium")`
    button {
      width: 100%;
    }
  `}
`;

export const Tabs = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  align-items: center;
  grid-gap: 10px;

  button {
    height: 50px;
    width: 100%;
  }

  ${media.lessThan("medium")`
    flex-direction: column;
    gap: 10px;

    width: 100%;
  `}
`;

export const Infos = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding: 15px;

  h1 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }
`;

export const RowText = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
